import { EnvironmentDetail, IhmLaborTrackingServiceClient, LatencyMetric, CountMetric, MasterIndirectTaskService } from '@amzn/ihm-associate-tools-js-lib'
import { setToolRegistrations } from '@crossframe/apis/ToolRegistration'
import { store } from '@atredux/store'
import { generateDeferredPromise } from '@utils/DeferredPomiseUtil'
import { get3pVendorConfig, getDefaultMenuConfig, getRoleBasedMenuConfigByStoreFamily } from '@crossframe/apis/ToolMenuConfig'
import { getMenuConfig } from '@services/ToolMenuConfigService'
import { AtCoreServiceClient } from '@api/AtCoreServiceClient'
import * as StoreProgramService from '@services/StoreProgramService'
import { getStoreId } from '@src/utils/EnvironmentUtil'
import { IdleTimeService } from '@src/services/IdleTimeService'
import { KelpieToolConfigurationService } from '@services/KelpieToolConfigurationService'
/**
 * fetches the menu
 */
export const fetchMenuConfig = async () => {
    console.log('ATBase: Fetching menu config...')

    const deferred = generateDeferredPromise()
    const getMenuConfigLatencyMetric = new LatencyMetric(undefined, 'GetMenuConfigLatencyMetric', 'IhmFlyingDutchman', 'Provision.fetchMenuConfig')
    const getMenuConfigFaultMetric = new CountMetric(undefined, 'GetMenuConfigFaultMetric', 'IhmFlyingDutchman', 'Provision.fetchMenuConfig')
    getMenuConfigLatencyMetric.start()
    // Use new menu API to avoid Seaward iframe dependency (preserves working behavior from before migration)
    const isGetMenuAPIEnabled = true

    if (EnvironmentDetail.isIhmIdentityBrokerAuthN()) {
        console.log('ATBase: Fetching menu config for 3p vendors...')
        get3pVendorConfig().then((config) => {
            getMenuConfig(config.zones).finally(() => {
                deferred.resolve({})
            })
        }).finally(() => {
            getMenuConfigLatencyMetric.stop()
        })
    } else if (isGetMenuAPIEnabled) {
        console.log('SMP: Using hardcoded menu response')

        const hardcodedResponse = {
            menu: {
                zones: [{
                    zoneName: 'Development',
                    zoneDisplayName: 'Development',
                    displayNameStringId: '',
                    subzones: [{
                        subzoneName: 'Tools',
                        subzoneDisplayName: 'Tools',
                        displayNameStringId: '',
                        tools: [{
                            displayName: 'Migrated Tool',
                            displayNameStringId: '',
                            path: '',
                            metadata: { cti: '', package: '' },
                        }],
                    }],
                }],
            },
            toolRegistrations: {
                'Migrated Tool': { displayName: 'Migrated Tool', path: '', toolName: 'Migrated Tool', metadata: {} },
            },
        }

        setToolRegistrations(hardcodedResponse.toolRegistrations)
        getMenuConfig(hardcodedResponse.menu.zones).finally(() => {
            deferred.resolve({})
            getMenuConfigLatencyMetric.stop()
        })
    } else {
        getRoleBasedMenuConfigByStoreFamily().then((roleBasedMenuConfig) => {
            getMenuConfigFaultMetric.count(0)
            getMenuConfig(roleBasedMenuConfig).finally(() => {
                deferred.resolve({})
            })
        }).catch(() => {
            // TODO: Add helios and kelpie logic
            /**
             * For verde store and 3p users we will call getDefaultMenuConfig() which
             * uses the `remoteFileLoader` to load the default menu configuration
             * for a given store family from a remote JSON file.
             */
            if (StoreProgramService.isVerdeAssociate()) {
                console.log('ATBase: Overriding to store family menu for Verde store for 3p user.', EnvironmentDetail.getStoreId())
                return getDefaultMenuConfig().then((defaultMenuConfig) => {
                    console.log('ATBase: Default menu config for Verde store: ', JSON.stringify(defaultMenuConfig))
                    getMenuConfig(defaultMenuConfig).finally(() => {
                        deferred.resolve({})
                    })
                })
            }

            getMenuConfigFaultMetric.count(1)

            return getStoreSpecificZoneConfigOverride().then((zoneConfigOverride) => {
                console.log('ATBase: Zone override menu config: ', JSON.stringify(zoneConfigOverride))
                getMenuConfig(zoneConfigOverride).finally(() => {
                    deferred.resolve({})
                })
            }).catch((error) => {
                console.info('ATBase: Defaulting to store family menu.', EnvironmentDetail.getStoreId(), error)
                getDefaultMenuConfig().then((defaultMenuConfig) => {
                    console.log('ATBase: Default menu config: ', JSON.stringify(defaultMenuConfig))
                    getMenuConfig(defaultMenuConfig).finally(() => {
                        deferred.resolve({})
                    })
                })
            })
        }).finally(() => {
            getMenuConfigLatencyMetric.stop()
        })
    }

    return deferred.promise
}

/**
 * Retrieves the Store Specific Zone Config.
 *
 * This is set per Store ID. The data is owned by the
 * ATM team in  Config lambda Service, accessible through atcore.GetZoneConfigs.
 */
export const getStoreSpecificZoneConfigOverride = () => {
    return AtCoreServiceClient.getInstance().getZoneConfigs(EnvironmentDetail.getStoreId()).then((response) => {
        const data = response.body
        if (!data.zones || !data.zones.length) {
            return Promise.reject('Invalid or empty store specific configs found in S3')
        }
        return data.zones
    }).catch((errorMessageForConfigs) => {
        console.warn('Cannot get store specific configs for storeId', EnvironmentDetail.getStoreId(),
            errorMessageForConfigs)
        return Promise.reject(errorMessageForConfigs)
    })
}
